import { putPostRequest } from "../../utilFunctions/Axios/AxiosRequestConfiguration";
import { BASE_URL, cdnUrl } from "../../utilFunctions/Constants/urlConstants";
import { uploadFileToS3 } from "utilFunctions/shared/uploadFileToS3";

class QuestionImageUpload {
  constructor(loader) {
    this.loader = loader;
    this.id = 1;
    this.assetType = "Image";
  }
  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          putPostRequest({
            url: BASE_URL + "asset/generate-presigned-url",
            method: "POST",
            body: {
              id: this.id,
              fileName: file.name,
              assetType: this.assetType,
            },
            success: (response) => {
              const data = response.data;
              const { preSignedUrl, url } = data?.data || {};
              if (preSignedUrl) {
                uploadFileToS3(file, preSignedUrl, new AbortController().signal)
                  .then(() => {
                    resolve({ default: cdnUrl + "/" + url });
                  })
                  .catch(() => {
                    reject("Upload failed");
                  });
              } else {
                reject("Could not get presigned URL");
              }
            },
            failure: (err) => {
              const errData = err?.response?.data || {};
              reject(errData["message"] || "Error");
            },
          });
        })
    );
  }
}

export { QuestionImageUpload };
